import React, { useEffect, useState } from 'react';
import { Icon } from '@chakra-ui/core';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiV1 } from '../common/api/api';
import { Funders } from '../common/components/Funders/Funders';
import routes from '../common/routes';
import QuoteQuestionDetails from './QuoteQuestionDetails';
import QuestionLoading from './QuestionLoading';
import { canManageQuestions } from './questionHelpers';

const QuoteQuestion = ({ match }) => {
  const { folderId, questionId } = match.params;
  const authentication = useSelector(state => state.authentication || {});
  const user = Object.keys(authentication.profile || {}).length
    ? authentication.profile
    : authentication.user;
  const internal = canManageQuestions(user);
  const [question, setQuestion] = useState(null);
  const [pending, setPending] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    setPending(true);
    setError(false);
    setQuestion(null);
    apiV1
      .get(
        `/folders/${encodeURIComponent(folderId)}/quote_tickets/${encodeURIComponent(questionId)}`,
      )
      .then(({ data }) => {
        if (active) setQuestion(data.quoteTicket || data.quote_ticket);
      })
      .catch(() => {
        if (active) setError(true);
      })
      .finally(() => {
        if (active) setPending(false);
      });

    return () => {
      active = false;
    };
  }, [folderId, questionId]);

  return (
    <div className="qq-page qq-single">
      <header className="qq-heading">
        <div>
          <div className="qq-eyebrow">
            <Icon name="comment" size="12px" aria-hidden="true" /> Relation entreprises
          </div>
          <h1>Question d’entreprise</h1>
          <p className="qq-subtitle">Votre échange et sa réponse, réunis dans le dossier.</p>
        </div>
        <Link className="qq-button" to={internal ? routes.quotes.questions : routes.quotes.index}>
          <Icon name="arrow-back" aria-hidden="true" />
          {internal ? 'Toutes les questions' : 'Retour au suivi des devis'}
        </Link>
      </header>
      <div className="qq-single-shell">
        <div className="qq-reader-content">
          {pending && <QuestionLoading />}
          {!pending && (error || !question) && (
            <div className="qq-notice qq-error" role="alert">
              Cette question est indisponible ou vous n’avez pas accès à ce dossier.
            </div>
          )}
          {!pending && question && (
            <>
              <div className="qq-context">
                <div>
                  <div className="qq-context-label">Votre dossier</div>
                  <div className="qq-context-name">
                    {question.folderRecipientName || 'Échange avec BelAvie'}
                  </div>
                </div>
                <span className="qq-context-dossier">
                  <Icon name="folder" color="coral.700" aria-hidden="true" />
                  Dossier n° {question.folderFormattedId}
                </span>
              </div>
              <QuoteQuestionDetails
                key={question.id}
                question={question}
                folderId={folderId}
                onChange={setQuestion}
              />
            </>
          )}
        </div>
        {!pending && question && (
          <div className="qq-single-footer">
            <Funders
              folderId={folderId}
              trigger={({ onClick }) => (
                <button className="qq-button" type="button" onClick={onClick}>
                  Consulter le dossier et son historique
                  <Icon name="arrow-forward" aria-hidden="true" />
                </button>
              )}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default QuoteQuestion;
